module.exports = __webpack_public_path__ + "fonts/k3k702ZOKiLJc3WVjuplzJ6vnaPZw6nYDxM4SVEMFKg.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/k3k702ZOKiLJc3WVjuplzJ6vnaPZw6nYDxM4SVEMFKg.woff2
// module id = 394
// module chunks = 0